import { render, staticRenderFns } from "./ImportFromPos.vue?vue&type=template&id=1943dfe7&lang=pug"
import script from "./ImportFromPos.vue?vue&type=script&lang=js"
export * from "./ImportFromPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports